import { render, staticRenderFns } from "./ModalSolicitarDiligenciaFornecedor.vue?vue&type=template&id=013b1b40&"
import script from "./ModalSolicitarDiligenciaFornecedor.vue?vue&type=script&lang=js&"
export * from "./ModalSolicitarDiligenciaFornecedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports